import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import App from "../App";
// import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
// import LoginRedirect from "../pages/Login/loginRedirect";
import { Provider } from "react-redux";
import store from "../redux/store";
import PurchasePage from "../pages/purchase/PurchasePage";
import RefinancePage from "../pages/refinance/RefinancePage";
// import RatesComponent from "../pages/rates/RatesComponent";
// import RateCardList from "../pages/rates/RateCardList";
import SubmitPage from "../pages/SubmitPage/SubmitPage";
import MeetingInfo from "../pages/MeetingInfo/MeetingInfo";
import useIframeScrollbar from "../hooks/useIframeScrollbar";
import useIframeLanguage from "../hooks/useIframeLanguage";
// import { getAccessToken } from "../helpers/helpers";

const MainRoutes = () => {
  // Hide scrollbars in iframe mode for entire application
  useIframeScrollbar();
  // Handle iframelang URL parameter in iframe mode
  useIframeLanguage();
//   const [token, setToken] = useState(getAccessToken());

  //   const appendAdminIdToURL = (pathname) => {
  //     const url = new URL(window.location.href);
  //     const searchParams = new URLSearchParams(url.search);

  //     if (!searchParams.has("lar")) {
  //       searchParams.set("lar", "admin");
  //     }
  //     return `${pathname}?${searchParams.toString()}`;
  //   };

  return (
    <Provider store={store}>
      <Router >
        <Routes>
          {/* Base Route */}
          <Route path={process.env.REACT_APP_BASE_URL} element={<App />} />

          {/* Purchase Route */}
          <Route
            path={process.env.REACT_APP_PURCHASE_URL}
            element={<PurchasePage />}
          />

          {/* Refinance Route */}
          <Route
            path={process.env.REACT_APP_REFINANCE_URL}
            element={<RefinancePage />}
          />

          {/* Locked Rates */}
          {/* <Route
                        path={process.env.REACT_APP_LOCKED_RATES_URL}
                        element={<RatesComponent />}
                    />

                    <Route
                        path={process.env.REACT_APP_RATES_URL}
                        element={
                            <div>
                                <AuthenticatedTemplate>
                                    <RateCardList />
                                </AuthenticatedTemplate>
                                <UnauthenticatedTemplate>
                                    <LoginRedirect setToken={(token) => setToken(token)} />
                                </UnauthenticatedTemplate>
                            </div>
                        }
                    /> */}
          <Route
            path={process.env.REACT_APP_THANKYOU_URL}
            element={<SubmitPage />}
          />
          <Route
            path={process.env.REACT_APP_MEETINGINFO_URL}
            element={<MeetingInfo />}
          />
        </Routes>
      </Router>
    </Provider>
  );
};

export default MainRoutes;
